import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container } from '../../../../ui/gridSystem';
import { NoResult, Text } from '../../../../ui/atoms';
import {
  ActivityCard,
  Legend,
  CompletionWrapper,
  SectionsContainer,
} from './style';
import { withMediaQueries } from '../../../hoc/withMediaQueries';
import { EVENT_SESSIONS_GET } from '../../../redux/actions/statistics';
import CustomTooltip from '../../../../ui/atoms/CustomTooltip';
import Inline from '../../../../ui/atoms/Inline';
import { getFilterLabel } from '../../../../utils/labels';
import theme from '../../../../ui/theme';
import { formatActivityInfo, timestampToDate } from '../../../../utils/common';

const Sessions = ({
  typology,
  sessions,
  visible_users,
  getCourseActivities,
}) => {
  const { course_id } = useParams();
  // filters
  // eslint-disable-next-line no-unused-vars
  const [selectedFilters, setSelectedFilters] = useState({});

  useEffect(() => {
    if (typology === 'event') {
      getCourseActivities(selectedFilters, course_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters, typology]);

  return (
    <Container className="pt-0">
      <Text type="h2" mb={34}>
        Report sessioni
      </Text>
      {sessions?.length > 0 ? (
        <SectionsContainer>
          {sessions.map((session, si) => (
            <div key={`session-${si}`}>
              {session?.title && (
                <>
                  <Text type="h2.5" mb={8}>
                    Sessione {si + 1}
                  </Text>
                  <Text type="h2.5" mb={8} color={theme().colors.textSecondary}>
                    {session?.title}
                  </Text>
                </>
              )}
              {/* Sorting is not present in figma
              <SortingWrapper>
                <SortBy
                  options={getSortingOptions([
                    'created_asc',
                    'created_desc',
                    'type_asc',
                    'type_desc',
                    'rate_asc',
                    'rate_desc',
                  ])}
                  onChange={(v) => {
                    setSelectedFilters({
                      ...selectedFilters,
                      sort_by: v?.value,
                    });
                  }}
                />
              </SortingWrapper> */}
              <Legend>
                <Text type="statistics-heading">Nome</Text>
                <Text type="statistics-heading">Tipologia</Text>
                <Text type="statistics-heading">Data e ora</Text>
                <Text type="statistics-heading">Assegnazioni</Text>
                <Text type="statistics-heading">Completamenti</Text>
                <Text type="statistics-heading">Accesso</Text>
                <Text type="statistics-heading">Registrazione</Text>
                <Text type="statistics-heading">Tempo medio di permanenza</Text>
                <CompletionWrapper>
                  <Text type="statistics-heading">Punteggio medio quiz</Text>
                  <CustomTooltip
                    type="primary"
                    title="Punteggio Medio Quiz"
                    tooltipKey="quiz_average_score"
                  />
                </CompletionWrapper>
              </Legend>
              {(session?.activities || []).map((activity, ai) => (
                <ActivityCard key={`activity-${ai}`}>
                  <CustomTooltip type="primary" title={activity.title}>
                    <Text type="h3" className="ellipsis">
                      {activity.title}
                    </Text>
                  </CustomTooltip>
                  <Text type="b4">{getFilterLabel(activity?.type) || '-'}</Text>
                  <Text type="b4">
                    {timestampToDate(formatActivityInfo(activity).tsStart)}
                    <br />
                    {activity?.start_time} {activity?.end_time} (
                    {formatActivityInfo(activity).duration})
                  </Text>

                  <Text type="b2">{visible_users || 0}</Text>
                  <Inline alignItems="baseline">
                    <Text type="b2">{activity?.completion ?? 0}</Text>
                    <Text type="b4">/{visible_users ?? 0}</Text>
                  </Inline>
                  <Text type="b4">
                    {activity?.access_type === 'free_access'
                      ? 'Libero'
                      : 'Limitato'}
                  </Text>
                  <Text type="b4">
                    {activity?.attendance === 'without_attendance'
                      ? 'Senza appello'
                      : 'Con appello'}
                  </Text>
                  <Text type="b4">{activity?.average_duration || '-'}</Text>
                  <Text type="b4">
                    {activity?.average_score
                      ? `${activity?.average_score}%`
                      : '-'}
                  </Text>
                </ActivityCard>
              ))}
              {session?.quiz && (
                <ActivityCard>
                  <CustomTooltip type="primary" title={session?.quiz?.title}>
                    <Text type="h3" className="ellipsis">
                      {session?.quiz?.title}
                    </Text>
                  </CustomTooltip>
                  <Text type="b4">Quiz</Text>
                  <Text type="b4">-</Text>

                  <Text type="b2">{visible_users || 0}</Text>
                  <Inline alignItems="baseline">
                    <Text type="b2">{session?.quiz?.completion ?? 0}</Text>
                    <Text type="b4">/{visible_users ?? 0}</Text>
                  </Inline>
                  <Text type="b4">-</Text>
                  <Text type="b4">-</Text>
                  <Text type="b4">{session?.quiz?.avg_duration}</Text>
                  <Text type="b4">
                    {session?.quiz?.avg_percentage
                      ? Number(session.quiz.avg_percentage).toFixed(2) * 100
                      : '0'}
                  </Text>
                </ActivityCard>
              )}
            </div>
          ))}
        </SectionsContainer>
      ) : (
        <NoResult />
      )}
    </Container>
  );
};

Sessions.propTypes = {
  // HOC: state
  typology: PropTypes.string,
  sessions: PropTypes.array,
  visible_users: PropTypes.number,
  //HOC: dispatch
  getCourseActivities: PropTypes.func,
};

export default connect(
  (state) => {
    const {
      activities: { sessions, visible_users },
      typology,
    } = state.statistics.course;
    return {
      typology,
      sessions,
      visible_users,
    };
  },
  (dispatch) => ({
    getCourseActivities: (filters, course_id) =>
      dispatch({ type: EVENT_SESSIONS_GET._REQUEST, filters, course_id }),
  })
)(withMediaQueries(Sessions));
